import styled from "styled-components";

export const WrapperSC = styled("section")`
  padding-top: 110px !important;
  @media(max-width: 768px) {
    padding-top: 50px !important;
  }
`;
